<template>
  <v-container fluid>
    <v-row>
      <v-col cols="4">
        <v-card class="mx-auto">
          <v-card-title>
            Historique des demandes d’éclaircissements
          </v-card-title>

          <v-card-text class="pt-4">Liste des demandes émisses sur la plateforme </v-card-text>

          <v-divider></v-divider>
          <v-virtual-scroll
            :items="this.$store.getters['Auth/getListMessage']"
            :item-height="50"
            height="400"
          >
            <template v-slot="{ item }">
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon large>mdi-mail</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{ item.senderFullName }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.senderEmail }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn @click="showMess(item)" depressed small>
                    Consulter le message
                    <v-icon color="orange darken-4" right>mdi-email-box</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-col>
      <v-col cols="8">
        <v-alert v-model="info" text color="prmary">
          <h3 class="headline">
            {{ showMessage.object }}
          </h3>
          <div class="text-truncate">
            {{ showMessage.content }}
          </div>

          <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>

          <v-row align="center" no-gutters>
            <v-col class="grow">
              {{ showMessage.senderFullName }}
            </v-col>
            <v-col class="grow">
              {{ showMessage.read }}
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="shrink">
              <v-btn small @click="info = !info" color="red" outlined>
                Fermer
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card>
          <v-card-text>
            <v-text-field
              filled
              label="Objet"
              v-model="message.object"
              persistent-hint
            ></v-text-field>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="message.sender_full_name"
                  label="Nom Complet du destinataire"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="message.sender_email"
                  label="Email du destinataire"
                  type="email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small @click="send" color="primary" right>
              <v-icon class="mr-2">mdi-email-send</v-icon>Répondre au message
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    info: false,
    showMessage: [],
    message: {
      object: "",
      content: "",
      sender_email: "",
      sender_full_name: ""
    },
    password: "Password",
    bread: [
      {
        text: "Tableau de bord",
        disabled: false,
        href: "/dashboard"
      },
      {
        text: "Demandes d’éclaircissements",
        disabled: true
      }
    ],
    show: false,
    marker: true,
    iconIndex: 0,
    icons: [
      "mdi-emoticon",
      "mdi-emoticon-cool",
      "mdi-emoticon-dead",
      "mdi-emoticon-excited",
      "mdi-emoticon-happy",
      "mdi-emoticon-neutral",
      "mdi-emoticon-sad",
      "mdi-emoticon-tongue"
    ],
    colors: [
      "#2196F3",
      "#90CAF9",
      "#64B5F6",
      "#42A5F5",
      "#1E88E5",
      "#1976D2",
      "#1565C0",
      "#0D47A1",
      "#82B1FF",
      "#448AFF",
      "#2979FF",
      "#2962FF"
    ],
    names: ["Ibrahima", "Soda", "Fanta"],
    surnames: ["Ndiaye", "Diop", "Seck"]
  }),

  computed: {
    icon() {
      return this.icons[this.iconIndex];
    },
    items() {
      const namesLength = this.names.length;
      const surnamesLength = this.surnames.length;
      const colorsLength = this.colors.length;

      return Array.from({ length: 10000 }, () => {
        const name = this.names[this.genRandomIndex(namesLength)];
        const surname = this.surnames[this.genRandomIndex(surnamesLength)];

        return {
          color: this.colors[this.genRandomIndex(colorsLength)],
          fullName: `${name} ${surname}`,
          initials: `${name[0]} ${surname[0]}`
        };
      });
    }
  },
  created() {
    this.loadAllMessage();
  },
  methods: {
    ...mapActions({
      send_message: "Auth/send_message",
      loadAllMessage: "Auth/loadAllMessage"
    }),
    showMess(item) {
      this.info = true;
      this.showMessage = item;
    },
    send() {
      const data = new FormData();
      data.append("object", this.message.object);
      data.append("sender_email", this.message.sender_email);
      data.append("sender_full_name", this.message.sender_full_name);
      data.append("content", this.message.content);
      this.send_message(data);
    },
    genRandomIndex(length) {
      return Math.ceil(Math.random() * (length - 1));
    }
  }
};
</script>
